import { WSList, WSText } from "@wingspanhq/fe-component-library";
import { useMemo } from "react";
import { FlowMEChangeContext } from "..";
import { useUserId } from "../../../../../query/hooks/helpers";
import {
  useQueryMemberProfile,
  useQueryUserProfile
} from "../../../../../query/users/queries";
import { useQueryUserProfileV2 } from "../../../../../query/user/queries/useQueryUserProfile";
import { useFlowContext } from "../../../../../shared/components/Flow";
import { verificationService } from "../../../../../shared/services/verificaiton";
import { getProfileDataPerson } from "../../../components/FormPartialPerson/getProfileDataPerson";
import { FormPersonalInformation } from "../../../components/FormPersonalInformation";
import { useRequiresBankingVerification } from "../../../hooks/useRequiresBankingVerification";
import { useMissingFields } from "../../../hooks/useMissingFields";
import { OnboardingStep } from "../../../types";

export const StepMaterialUpdatePersonalInformation: React.FC<
  OnboardingStep
> = props => {
  const [context, setContext] = useFlowContext<FlowMEChangeContext>();
  const requiresBanking = useRequiresBankingVerification();
  const verificationLevel = requiresBanking ? "Banking" : "Tax";

  const userId = useUserId();
  const queryUser = useQueryUserProfile(userId);
  const queryMember = useQueryMemberProfile(userId);
  const queryUserV2 = useQueryUserProfileV2();
  const profileData = useMemo(
    () => ({
      person: getProfileDataPerson({
        type: "Individual",
        user: queryUser.data,
        member: queryMember.data,
        userV2: queryUserV2.data
      })
    }),
    [queryMember.data, queryUser.data, queryUserV2.data]
  );

  const missingFields = useMissingFields(verificationLevel);

  const isMismatch = useMemo(
    () => verificationService.getIsIndividualMismatch(missingFields),
    [missingFields]
  );

  return (
    <WSList gap="2XL">
      <FormPersonalInformation
        defaultValues={context.personalInformation || profileData}
        onBack={props.onBack}
        onSubmit={data => {
          setContext(prev => ({ ...prev, personalInformation: data }));
          props.onNext?.();
        }}
        country={context.accountType?.country || "US"}
        mismatch={isMismatch}
      />

      <WSText.ParagraphXs color="gray400">
        The information on this page is required to request a taxpayer
        information update, if you exit or leave without completing this step,
        it will cancel the request.
      </WSText.ParagraphXs>
    </WSList>
  );
};
